<template>
  <el-dialog
    :title="$t('change password')"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="!forced"
    :show-close="!forced"
    width="480px"
    class="change-password-dialog"
    @close="onClose"
  >
    <p v-if="forced" class="force-tip">{{ $t('your password is expired, please change your password.') }}</p>
    <el-form ref="form" :model="form" label-width="120px" id="changePasswordForm">
      <el-form-item :label="$t('old pass')" prop="oldPassword">
        <el-input v-model="form.oldPassword" type="password" show-password autocomplete="off" />
      </el-form-item>
      <el-form-item :label="$t('new pass')" prop="newPassword">
        <el-input v-model="form.newPassword" type="password" show-password autocomplete="off" @input="filterChinesePassword('newPassword')" />
      </el-form-item>
      <el-form-item :label="$t('confirm')" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" type="password" show-password autocomplete="off" @input="filterChinesePassword('confirmPassword')" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button v-if="!forced" @click="handleCancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">{{ $t('change') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as api from '@/api/endpoints'
import { eventBus } from '@/router'

export default {
  name: 'ChangePasswordDialog',
  data() {
    return {
      visible: false,
      loading: false,
      forced: false,
      form: { oldPassword: '', newPassword: '', confirmPassword: '' }
    }
  },
  mounted() {
    eventBus.$on('show-change-password-dialog', this.show)
  },
  beforeDestroy() {
    eventBus.$off('show-change-password-dialog', this.show)
  },
  methods: {
    show(options = {}) {
      this.forced = !!options.forced
      this.form = { oldPassword: '', newPassword: '', confirmPassword: '' }
      this.visible = true
    },
    filterChinesePassword(field) {
      this.form[field] = this.form[field].replace(/[一-鿿]/g, '')
    },
    async handleSubmit() {
      if (this.form.newPassword !== this.form.confirmPassword) {
        this.$message.error(this.$t('new password and confirm password should be the same'))
        return
      }
      this.loading = true
      try {
        await api.changePassword(this.form.oldPassword, this.form.newPassword)
        this.$message.success(this.$t('password update successfully'))
        this.visible = false
        eventBus.$emit('change-password-done', { success: true })
      } catch (e) {
        this.$message.error(this.$t('password update failed, please make sure the old password is correct'))
        eventBus.$emit('change-password-failed')
        // Keep dialog open so user can retry
        return
      } finally {
        this.loading = false
      }
    },
    handleCancel() {
      this.visible = false
      eventBus.$emit('change-password-failed')
    },
    onClose() {
      this.form = { oldPassword: '', newPassword: '', confirmPassword: '' }
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.force-tip {
  color: #84226D;
  padding-bottom: 20px;
  font-weight: 500;
}
</style>
